<template>
  <tr>
    <td>
      <div class="table-number-cell form-control-static">{{ pIndex + 1 }}</div>
      <input type="hidden" v-model="taskRule.id" :name="pInputPrefix + 'id'"/>
    </td>
    <td class="text-nowrap">
      <a class="btn btn-default btn-sm" @click.prevent="copyTaskRule"><i class="fa-light fa-copy"></i></a>
      <a class="btn btn-default btn-sm" @click.prevent="removeTaskRule"><i class="fa-light fa-trash-alt"></i></a>
    </td>
    <td :class="{'has-error': hasFieldErrors(pInputPrefix + 'name')}">
      <input v-model="taskRule.name" class="form-control input-sm" :id="pClassPrefix + 'name'"
             :name="pInputPrefix + 'name'" type="text"/>
      <span v-for="(error, errorIndex) in getFieldErrors(pInputPrefix + 'name')"
            :key="'errorList' + pClassPrefix + 'name' + errorIndex" class="help-block">{{ error }}</span>
    </td>
    <td :class="{'has-error': hasFieldErrors(pInputPrefix + 'description')}">
      <textarea ref="descriptionRte" v-model="taskRule.description" class="form-control input-sm summernote"
                :id="pClassPrefix + 'description'"
                :name="pInputPrefix + 'description'" type="text"/>
      <span v-for="(error, errorIndex) in getFieldErrors(pInputPrefix + 'description')"
            :key="'errorList' + pClassPrefix + 'description' + errorIndex" class="help-block">{{ error }}</span>
    </td>
    <td :class="['col-xs-1', {'has-error': hasFieldErrors(pInputPrefix + 'nbOfDaysToProductionDateText')}]">
      <input v-model="taskRule.nbOfDaysToProductionDateText" class="form-control input-sm text-center"
             :name="pInputPrefix + 'nbOfDaysToProductionDateText'" type="text"/>
      <span v-for="(error, errorIndex) in getFieldErrors(pInputPrefix + 'nbOfDaysToProductionDateText')"
            :key="'errorList' + pClassPrefix + 'nbOfDaysToProductionDateText' + errorIndex" class="help-block">{{ error }}</span>
    </td>
    <td :class="['col-xs-1', {'has-error': hasFieldErrors(pInputPrefix + 'nbOfDaysToDeliveryDateText')}]">
      <input v-model="taskRule.nbOfDaysToDeliveryDateText" class="form-control input-sm text-center"
             :name="pInputPrefix + 'nbOfDaysToDeliveryDateText'" type="text"/></td>
    <span v-for="(error, errorIndex) in getFieldErrors(pInputPrefix + 'nbOfDaysToDeliveryDateText')"
          :key="'errorList' + pClassPrefix + 'nbOfDaysToDeliveryDateText' + errorIndex" class="help-block">{{ error }}</span>
    <td>
      <project-priority-select
          v-model="priorityId"
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          :p-label-visible="false"
          :p-error-key="pInputPrefix + 'priorityRef'"
          :p-input-name="pInputPrefix + 'priorityRef.id'"
          p-style-class="btn-group-sm"
          p-select-container="#bsProjectTemplateSaveFormDialog">
      </project-priority-select>
    </td>
    <td>
      <input ref="roleAssignmentsActiveRef"
             type="checkbox" v-model="taskRule.roleAssignmentsActive" value="true"
             :data-on="pDictionary['dictionary.general.on']"
             :data-off="pDictionary['dictionary.general.off']"
             data-onstyle="success bs3-label" data-offstyle="default bs3-label" data-size="small"
             :name="pInputPrefix + 'roleAssignmentsActive'" class=""/>
      <table class="table table-striped bs3-vertical-center bs3-margin-top bs3-margin-bottom-reset" v-show="taskRule.roleAssignmentsActive">
        <tbody>
          <tr v-for="(roleAssignment, raIndex) in taskRule.roleAssignments" :key="roleAssignment.roleRef.id">
            <td>
              {{ i18nRefName(roleAssignment.roleRef, pLanguage) }}
              <input v-model="roleAssignment.roleRef.id"
                     class="form-control input-sm" :id="pClassPrefix + 'roleAssignmentByRoleId' + raIndex + '_roleRef_id'"
                     :name="pInputPrefix + 'roleAssignments[' + raIndex +'].roleRef.id'" type="hidden"/>
            </td>
            <td>
              <project-template-save-form-task-rule-role-assignment-user
                  v-model="roleAssignment.userRef"
                  :p-currencies="pCurrencies"
                  :p-language="pLanguage"
                  :p-dictionary="pDictionary"
                  :p-urls="pUrls"
                  :p-error-list="pErrorList"
                  :p-src="pSrc"
                  :p-src-id="pSrcId"
                  :p-user-ref-list="pUserRefsByRoleId[roleAssignment.roleRef.id]"
                  :p-class-prefix="pClassPrefix + 'roleAssignments' + raIndex + '_userRef_'"
                  :p-input-prefix="pInputPrefix + 'roleAssignments[' + raIndex +  '].userRef.'">
              </project-template-save-form-task-rule-role-assignment-user>
            </td>
            <td :key="'effort' + roleAssignment.roleRef.id" :class="{'has-error': hasFieldErrors(pInputPrefix + 'roleAssignments[' + raIndex + '].effortText')}">
              <input v-model="taskRule.roleAssignments[raIndex].effortText"
                     class="form-control input-sm" :id="pClassPrefix + 'roleAssignmentByRoleId' + raIndex + '_name'"
                     :name="pInputPrefix + 'roleAssignments[' + raIndex +'].effortText'" type="text" placeholder="Effort"
                     style="min-width: 55px;"/>
              <span v-for="(error, errorIndex) in getFieldErrors(pInputPrefix + 'roleAssignments[' + raIndex + '].effortText')"
                    :key="'errorList' + pClassPrefix + 'roleAssignments' + raIndex +  '_effortText' + errorIndex" class="help-block">{{
                  error }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import ProjectPrioritySelect from "@/components/modules/administration-module/project-priority/ProjectPrioritySelect";
import refHelpers from "@/helpers/ref-helpers";
import eventhelpers from "@/helpers/event-helpers"
import ProjectTemplateSaveFormTaskRuleRoleAssignmentUser
  from "@/components/modules/production-module/project-template/form-save/ProjectTemplateSaveFormTaskRuleRoleAssignmentUser";

export default {
  name: "ProjectTemplateSaveFormTaskRule",
  components: {ProjectTemplateSaveFormTaskRuleRoleAssignmentUser, ProjectPrioritySelect},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pIndex: Number,
    pTaskRule: Object,
    pUserRefsByRoleId: Object,
    pInputPrefix: String,
    pClassPrefix: String
  },
  data: function () {
    return {
      taskRule: this.pTaskRule,
      priorityId: refHelpers.getRefId(this.pTaskRule.priorityRef, null)
    }
  },
  methods: {
    copyTaskRule()
    {
      this.$emit('copy-task-rule', this.taskRule);
    },
    removeTaskRule()
    {
      this.$emit('remove-task-rule', this.taskRule);
    }
  },
  mounted: function () {
    let _component = this;

    _component.$nextTick(function () {
    let $roleAssignmentsActive = $(_component.$refs.roleAssignmentsActiveRef);
    $roleAssignmentsActive.bootstrapToggle();
    $roleAssignmentsActive.change(function() {
      _component.taskRule.roleAssignmentsActive = $roleAssignmentsActive.prop('checked');
    })});

    //
    // Init SummerNotes
    //
    let $descriptionRte = $(_component.$refs.descriptionRte);
    $descriptionRte.summernote({
                                 shortcuts: false,
                                 disableDragAndDrop: true,
                                 dialogsInBody: true,
                                 toolbar: [
                                    ['style', ['bold', 'italic', 'underline']],
                                    ['font', ['strikethrough', 'superscript', 'subscript', 'clear']],
                                    ['fontsize', ['fontsize']],
                                    ['color', ['color']],
                                    ['para', ['ul', 'ol', 'paragraph']],
                                    ['insert', ['link','checkbox']]
                                 ],
                                 lang: (_component.pLanguage === 'fr' ? 'fr-FR' : 'en-US')
                               });

    $descriptionRte.on('summernote.change', function (we, contents, $editable) {
      eventhelpers.triggerNativeEvent($descriptionRte.get(0), 'input');
    });
  },
  destroyed: function () {
    var _component = this;

    let $roleAssignmentsActive = $(_component.$refs.roleAssignmentsActiveRef);
    $roleAssignmentsActive.bootstrapToggle('destroy');
    $roleAssignmentsActive.off('change');

    //
    // Destroy SummerNotes
    //
    var $descriptionRte = $(_component.$refs.descriptionRte);
    $descriptionRte.summernote('destroy');
  }
}
</script>

<style scoped>

</style>